export default __webpack_public_path__ + "static/media/cp-loanInfo.4aad67b8.png";